import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Helmet } from 'react-helmet';
import './baby-teething.css';
import Right from '../../right/Right';
import { fetchInitialData4 } from "../../fetchData";
import * as actions from '../Actions';
import Eruption from './Eruption';
import Shedding from './Shedding';
import ChildTeethInfo from './ChildTeethInfo';
import Articles from './Articles';
import AddToothDetails from './AddToothDetails';
import * as teethactions from './TeethingActions';

import Service from '../../service/Service';
const service = new Service();

class BabyTeething extends Component {
    constructor(props) {
        super(props);
        let initialData = {};
        this.currentY = 0;
        this.currentM = 0;
        if (__isBrowser__ && window.__initialData__ && window.__initialData__['initialData']) {
            initialData = window.__initialData__['initialData'];
            delete window.__initialData__;
        } else {
            if (props.staticContext && props.staticContext.initialData && props.staticContext.initialData['initialData']) {
                initialData = props.staticContext.initialData['initialData'];
            }
        }
        this.state = {
            initialData: initialData,
            activeRef: 'active-tab',
            activeTotRef: '',
            activeArti: '',
            activeErp: 'active-ref-tab',
            tabarrow: 'erparrow',
            activeShed: '',
            toothNo: 0,
            currentMonth: '',
            image: '',
            clickwedWeek: '',
            scrollwidth: '',
            halfwidth: '',
            weekwd: '',
            weeks: '',
            showmsg: false,
            isshowRef: '',
            isshowArt: '',
            isshowChildTeeth: '',
            isshowErpt: true,
            isshowShed: false,
            allteeth: '',
            monthSlider: '',
            isshowDropdown: '',
            teethCount: '',
            isshowDetails: false,
            insertThisTooth: '',
            TeethEruptionData: [],
            TeethSheddingData: [],
            ChildTeethData: [],
            ArticlesData: [],
            selectedChlDOB: 0
        }
    }

    static initialAction(reqUrl, ftk, authData, uId, childData) {
        var header = {
            'Content-Type': 'application/json',
            'ftk': global.ftk,
            'uid': global.uID,
            'access-token': global.accessToken,
            'user-agent': global.userAgent,
            'isdesktop': global.isdesktop
        }
        let size = 10;
        if (reqUrl.includes('/page/')) {
            size = parseInt(reqUrl.split('/').pop()) * 10;
        }
        let body = JSON.stringify({})
        let obj1 = {
            url: global.api_url + "teeth/getreferenceteetheruptiondetail",
            body: JSON.stringify({
                "pagesize": 10,
                "pageno": 1,
                "isIntent": true,
                "isDesk": true
            })
        };
        let obj2 = {
            url: global.api_url + "teeth/getreferenceteethshedingdetail",
            body: JSON.stringify({
                "pagesize": 10,
                "pageno": 1,
                "isIntent": true,
                "isDesk": true
            })
        };
        let obj3 = {
            url: global.api_url + "teeth/getchildteetheruptiondetail",
            body: JSON.stringify({
                "pagesize": 10,
                "pageno": 1,
                "isIntent": true,
                "isDesk": true
            })
        };
        let obj4 = {
            url: global.api_url + "teeth/getteetharticle",
            body: JSON.stringify({
                "pagesize": 10,
                "pageno": 1,
                "isIntent": true,
                "isDesk": true
            })
        };
        return fetchInitialData4(obj1, obj2, obj3, obj4, JSON.stringify(header));
    }

    componentDidMount() {
        document.addEventListener("click", actions.domClick);
        if (navigator.onLine) {
           if (!this.state.initialData || (this.state.initialData && Object.keys(this.state.initialData).length < 1)) {
                    service.showLoader();
                    let childarray = global.userAry['childData']['UserChildList'];
                    let selectedChlId = 0;
                    if (childarray.length >= 1 && !childarray[0].IsExpected) {
                        selectedChlId = childarray[0] && childarray[0].ChildId ? childarray[0].ChildId : '';
                    }
                    else if (childarray.length >= 2 && childarray[0].IsExpected) {
                        selectedChlId = childarray[1] && childarray[1].ChildId ? childarray[1].ChildId : '';
                    }
                this.setState({
                    selectedChlId: selectedChlId,
                }, () => {
                    this.getErptData(selectedChlId);
                    this.getShedData(selectedChlId);
                    this.getChildData(selectedChlId);
                    this.getArticleData();
                });
                this.loadStateData();
                localStorage.setItem('BabyTeethingData', JSON.stringify(this.state.initialData));
            } else {
                localStorage.setItem('BabyTeethingData', JSON.stringify(this.state.initialData));
                this.loadStateData();
            }
        } else {
            if (localStorage.getItem('BabyTeethingData')) {
                this.setState({
                    initialData: JSON.parse(localStorage.getItem('BabyTeethingData'))
                });
                this.loadStateData();
            }
            service.hideLoader();
        }
    }

    componentWillUnmount() {
        document.removeEventListener("click", actions.domClick);
    }

    loadStateData() {
        if (global.ftk !== '') {
            this.setState({ isLogin: true, showChildrenList: true });
        } else {
            this.setState({ isLogin: false, showChildrenList: false });
        }
        this.setState({
            activeRef: 'active-tab',
            activeErp: 'active-ref-tab',
            tabarrow: 'erparrow',
            isshowRef: true,
            isshowArt: false,
            isshowChildTeeth: false,
            isshowErpt: true,
            isshowShed: false,
            isshowDropdown: false,
            isshowDetails: false,
            defaultArtImg: false,
            isreadmore: false
        });
        this.loadteethingdata();
        setTimeout(() => {
            try {
                this.state.scrollwidth = document.querySelector('.baby-teething-tool').offsetWidth;
                this.state.halfwidth = this.state.scrollwidth / 2;
                this.state.weekwd = document.querySelector('.week-bar li').offsetWidth;
                this.state.weeks = document.querySelectorAll('.week-bar li');
                let a;
                for (let j = 1; j <= document.querySelectorAll('.week-bar li').length; j++) {
                    let wd = j * this.state.weekwd;
                    if (wd > this.state.halfwidth) {
                        a = j - 1;
                        this.setState({ centerMonth: j - 1 });
                        break
                    }
                }
                for (let i = 0; i <= document.querySelectorAll('.week-bar li').length; i++) {
                    if (this.state.weeks[i].classList.contains('curr-week')) {
                        document.querySelector('.weeks-section').scrollLeft = ((this.state.weekwd * (i - a)));
                        break
                    }
                }
            } catch (err) {
                return "";
            }
        }, 100)
    }

    getErptData(childId) {
        var postData = {
            "childId": childId
        };
        var url = global.api_ci_url + "BabyTeething/getErptData";
        service.postServiceCall(url, postData).then((json) => {
            if (json['result']) {
                let initialData = this.state.initialData;
                initialData['data1'] = json;
                this.setState({
                    initialData: initialData,
                    // TeethEruptionData: json['result']
                });
                // , () => { this.loadStateData(); });
                this.currentM = json['currentMonth'];
            }
            service.hideLoader();
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
        });
    }

    getShedData(childId) {
        var postData = {
            "childId": childId
        };
        var url = global.api_ci_url + "BabyTeething/getShedData";
        service.postServiceCall(url, postData).then((json) => {
            if (json['result']) {
                let initialData = this.state.initialData;
                initialData['data2'] = json;
                this.setState({
                    initialData: initialData,
                    // TeethSheddingData: json['result']
                });
                // , () => { this.loadStateData(); });
                var chlDOB = document.querySelector("#selectedChildDOB").value;
                this.currentY = teethactions.getCurrentYear(chlDOB);
                setTimeout(() => {
                    teethactions.changeData(this, this.currentM, this.currentY);
                }, 500)
            }
            service.hideLoader();
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
        });
    }

    getChildData(childId) {
        var postData = {
            "childId": childId
        };
        var url = global.api_ci_url + "BabyTeething/getChildData";
        service.postServiceCall(url, postData).then((json) => {
            // debugger;
            if (json['result']) {
                let initialData = this.state.initialData;
                initialData['data3'] = json;
                this.setState({
                    initialData: initialData,
                    ChildTeethData: json['result']
                });
                // , () => { this.loadStateData(); });
                this.currentM = json['currentMonth'];
                let teeth_Count = 0;
                for (let i = 0; i < json['result'].length; i++) {
                    if (json['result'][i].isHighLited != 0) {
                        teeth_Count += 1;
                    }
                }
                this.setState({ teethCount: teeth_Count });
                setTimeout(() => {
                    teethactions.changeData(this, this.currentM, this.currentY);
                }, 500)
            }
            service.hideLoader();
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
        });
    }

    getArticleData() {
        var postData = {};
        var url = global.api_ci_url + "BabyTeething/getArticleData";
        service.postServiceCall(url, postData).then((json) => {
            if (json['result']) {
                let initialData = this.state.initialData;
                initialData['data4'] = json;
                this.setState({
                    initialData: initialData,
                    // ArticlesData: json['result']['ArticleInfo']
                });
                // , () => { this.loadStateData(); });
                  this.setState({
                       currentMonth: this.state.initialData.data1.currentMonth
                          });
                  this.currentM = this.state.initialData.data1.currentMonth;
                  this.setState({ 
                      TeethEruptionData: this.state.initialData.data1.result
                      });
            }
            service.hideLoader();
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
        });
    }

    showTabContent(tab) {
        if (this.state.isLogin && global.userAry['childData']['UserChildList']) {
            this.setState({ showChildrenList: true });
        }
        if (tab == 'ref') {
            this.setState({
                activeRef: 'active-tab',
                activeTotRef: '',
                activeArti: '',
                isshowRef: true,
                isshowArt: false,
                isshowChildTeeth: false,
                isshowErpt: true,
                isshowShed: false,
                activeErp: 'active-ref-tab',
                activeShed: '',
                tabarrow: 'erparrow',
                TeethEruptionData: this.state.initialData.data1.result
            });
        } else if (tab == 'totref') {
            this.setState({
                activeRef: '',
                activeTotRef: 'active-tab',
                activeArti: '',
                isshowRef: false,
                isshowArt: false,
                isshowChildTeeth: true,
                ChildTeethData: this.state.initialData.data3.result
            });
        } else {
            this.setState({
                activeRef: '',
                activeTotRef: '',
                activeArti: 'active-tab',
                isshowRef: false,
                isshowArt: true,
                isshowChildTeeth: false,
                showChildrenList: false,
                ArticlesData: this.state.initialData.data4.result.ArticleInfo
            });
            // var articleimg = document.querySelector('.article-img');
            // for (var i = 0; i < articleimg.length; i++) {
            //     if (articleimg[i].offsetHeight == 0) {
            //         this.setState({defaultArtImg: true})
            //     }
            // }
        }
        if (tab == 'ref' || tab == 'totref') {
            setTimeout(() => {
                teethactions.changeData(this, this.currentM, this.currentY);
            }, 100);
        }
    }
    showRefContent(tab) {
        if (tab == 'erp') {
            this.setState({
                activeErp: 'active-ref-tab',
                activeShed: '',
                tabarrow: 'erparrow',
                isshowErpt: true,
                isshowShed: false,
                TeethEruptionData: this.state.initialData.data1.result
            });
        } else {
            this.setState({
                activeErp: '',
                activeShed: 'active-ref-tab',
                tabarrow: 'shedarrow',
                isshowErpt: false,
                isshowShed: true,
                TeethSheddingData: this.state.initialData.data2.result
            });
        }
        setTimeout(() => {
            teethactions.changeData(this, this.currentM, this.currentY);
        }, 100);
    }
    showtoastmsg() {
        this.setState({ showmsg: true });
        setTimeout(() => {
            this.setState({ showmsg: false })
        }, 3000);
    }

    loadteethingdata() {
        let childarray = global.userAry['childData']['UserChildList'];
        this.getArticleData();
        if (global.ftk && childarray) {
            // this.setState({
            //     currentMonth: this.state.initialData.data1.currentMonth
            // });
            // this.currentM = this.state.initialData.data1.currentMonth;
            var chlDOB;
            if (childarray.length != 0) {
                if (childarray[0].IsExpected && childarray.length == 1) {
                    this.setState({
                        currentMonth: 0,
                        currentYear: 0
                    });
                    this.currentY = 0;
                    this.currentM = 0;
                    setTimeout(() => {
                        this.weekInfo(1, 1);
                    }, 50)
                }
                else if (!childarray[0].IsExpected && childarray.length >= 1) {
                    this.setState({
                        selectedChlId: childarray[0].ChildId,
                        selectedChlDOB: childarray[0].DOB,
                        selectedChlname: childarray[0].ChildName
                    });
                    chlDOB = childarray[0].DOB;
                    // this.showTeethingData(1, childarray[0].ChildId);
                    this.getErptData(childarray[0].ChildId);
                    this.getShedData(childarray[0].ChildId);
                    this.getChildData(childarray[0].ChildId);
                    this.setState({
                        currentMonth: this.currentM
                    });
                }
                else if (childarray[0].IsExpected && childarray.length >= 2) {
                    this.setState({
                        selectedChlId: childarray[1].ChildId,
                        selectedChlDOB: childarray[1].DOB,
                        selectedChlname: childarray[1].ChildName
                    });
                    chlDOB = childarray[0].DOB
                    // this.showTeethingData(1, childarray[1].ChildId);
                    this.getErptData(childarray[1].ChildId);
                    this.getShedData(childarray[1].ChildId);
                    this.getChildData(childarray[1].ChildId);
                    // this.getArticleData();
                    this.setState({
                        currentMonth: this.currentM
                    });
                }
            }
            // var curryr = teethactions.getCurrentYear(chlDOB);
            // console.log("*** ",curryr);
            // this.currentY = curryr;
            // this.setState({ 
            //     currentYear: curryr
            // });

        } else {
            console.log("not logged in");
            this.setState({
                currentMonth: 0,
                currentYear: 0,
                showChildrenList: false
            });
            this.currentY = 0;
            this.currentM = 0;
            setTimeout(() => {
                this.weekInfo(1, 1);
            }, 50)
        }
        // this.setState({ 
        //     TeethEruptionData: this.state.initialData.data1.result
        // });
    }

    weekInfo(tet, monthNo) {
        this.setState({ clickwedWeek: monthNo });
        let ul;
        if (document.querySelector(".reference-tab").className.includes('active-tab') && document.querySelector("#errp-tab").className.includes('active-ref-tab')) {
            ul = document.querySelector('.erruption-sect .monthbar');
        } else if (document.querySelector(".reference-tab").className.includes('active-tab') && document.querySelector("#shed-tab").className.includes('active-ref-tab')) {
            ul = document.querySelector('.shedding-sect .yearbar');
        } else {
            ul = document.querySelector('.tooth-erptn-section .monthbar');
        }

        let alllist = ul.getElementsByTagName('li');
        let thismonth;
        let currentindex;
        for (let j = 0; j < alllist.length; j++) {
            if (monthNo == alllist[j].firstChild.firstChild.innerText) {
                thismonth = alllist[j];
                currentindex = j;
                break;
            }
        }
        if (!thismonth.firstChild.children[0].classList.contains('weekcircle') && !thismonth.classList.contains('sel-week')) {
            thismonth.classList.add('sel-week');
            thismonth.firstChild.children[0].classList.add("greycircle");
            thismonth.firstChild.children[1].classList.add("wk-txt");
            if (ul.className.includes('yearbar')) {

                thismonth.firstChild.children[1].innerHTML = "Years";
            } else {
                thismonth.firstChild.children[1].innerHTML = "Months";
            }
        } else if (!thismonth.classList.contains('curr-week') && thismonth.firstChild.children[0].classList.contains('weekcircle')) {
            thismonth.classList.add('curr-week');
            thismonth.firstChild.children[1].classList.add("currentweek");
            if (ul.className.includes('yearbar')) {
                thismonth.firstChild.children[1].innerHTML = "Current<br />Year";
            } else {
                thismonth.firstChild.children[1].innerHTML = "Current<br />Month";
            }
        }
        for (let i = 0; i < alllist.length; i++) {
            if (thismonth != alllist[i]) {
                alllist[i].classList.remove('sel-week');
                alllist[i].classList.remove('curr-week');
                alllist[i].firstChild.children[0].classList.remove("greycircle");
                alllist[i].firstChild.children[1].classList.remove("wk-txt");
                alllist[i].firstChild.children[1].innerHTML = "";
            }
        }

        for (let i = 1; i <= alllist.length; i++) {
            let wd = i * this.state.weekwd;
            if (wd > this.state.halfwidth) {
                if (currentindex >= i - 1) {
                    let scrolllft = ((currentindex - (i - 1)) * this.state.weekwd);
                    document.querySelector('.weeks-section').scrollLeft = scrolllft;
                    break
                } else {
                    document.querySelector('.weeks-section').scrollLeft = 0;
                    break
                }
            }
        }
        if (document.querySelector(".reference-tab").className.includes('active-tab') && document.querySelector("#errp-tab").className.includes('active-ref-tab') && tet != 0) {
            this.setState({
                allteeth: document.querySelector(".erruption-sect").getElementsByClassName("baby-teeth")
            })
            this.erptnInfo(monthNo);
        } else if (document.querySelector(".reference-tab").className.includes('active-tab') && document.querySelector("#shed-tab").className.includes('active-ref-tab') && tet != 0) {
            this.setState({
                allteeth: document.querySelector(".shedding-sect").getElementsByClassName("baby-teeth")
            })
            this.shedInfo(monthNo);
        } else if (document.querySelector(".tooth-erptn-tab").className.includes('active-tab')) {
            this.setState({
                allteeth: document.querySelector(".tooth-erptn-section").getElementsByClassName("baby-teeth")
            })
            this.chlErptnInfo(monthNo);
        }
    }
    displayMonthslider() {
        let monthslider = [];
        for (let i = 1; i <= 36; i++) {
            if (this.state.currentMonth == i) {
                monthslider.push(
                    <li key={i} className="curr-week" id={"month_" + i} onClick={(e) => this.weekInfo(1, i)}>
                        <div className="allweeks">
                            <span className="week weekcircle">
                                <span>{i}</span>
                            </span>
                            <span className="currentweek">Current<br />Month</span>
                        </div>
                    </li>
                )
            } else {
                monthslider.push(
                    <li key={i} id={"month_" + i} onClick={(e) => this.weekInfo(1, i)}>
                        <div className="allweeks">
                            <span className="week">
                                <span>{i}</span>
                            </span>
                            <span className=""></span>
                        </div>
                    </li>
                )
            }
        }
        return monthslider;
    }
    displayYearslider() {
        let yearslider = [];
        for (let i = 6; i <= 12; i++) {
            if (this.state.currentYear == i) {
                yearslider.push(
                    <li key={i} className="curr-week" id={"month_" + i} onClick={(e) => this.weekInfo(1, i)}>
                        <div className="allweeks">
                            <span className="week weekcircle">
                                <span>{i}</span>
                            </span>
                            <span className="currentweek">Current<br />Year</span>
                        </div>
                    </li>
                )
            } else {
                yearslider.push(
                    <li key={i} id={"month_" + i} onClick={(e) => this.weekInfo(1, i)}>
                        <div className="allweeks">
                            <span className="week">
                                <span>{i}</span>
                            </span>
                            <span className=""></span>
                        </div>
                    </li>
                )
            }
        }
        return yearslider;
    }
    slideLeft = (id) => {
        if (id > 1) {
            this.weekInfo(1, id - 1);
        }
    }

    slideRight = (id) => {
        if (id < 36) {
            this.weekInfo(1, id + 1);
        }
    }

    showDet(mon, e) {
        let thisteeth = document.querySelector("#" + e);
        if (document.querySelector(".reference-tab").className.includes('active-tab') && document.querySelector("#errp-tab").className.includes('active-ref-tab')) {
            let highlighted, erpStartMonth, erpEndMonth;
            let teethinfo = '';
            let TeethEruptionData = this.state.TeethEruptionData;
            for (let i = 0; i < TeethEruptionData.length; i++) {
                if (TeethEruptionData[i].toothNumber == thisteeth.firstChild.innerText) {
                    this.setState({
                        toothName: TeethEruptionData[i].toothName,
                        toothMonth: TeethEruptionData[i].startMonthEruption + '-' + TeethEruptionData[i].endMonthEruption + ' months'
                    });
                    highlighted = TeethEruptionData[i].highlightedTeeth;
                    erpStartMonth = TeethEruptionData[i].startMonthEruption;
                    break;
                }
            }
            if (mon != 0) {
                this.weekInfo(0, erpStartMonth);
            }
            document.querySelector(".erruption-sect .tooth-info").style.display = "block";
            document.querySelector(".erruption-sect .lower-jaw").style.display = "none";
            document.querySelector(".erruption-sect .upper-jaw").style.display = "none";

            let allteeth = this.state.allteeth;
            let highlightedId = highlighted.split(",");
            for (let i = 0; i < allteeth.length; i++) {
                allteeth[i].children[1].style.display = "none";
                if (allteeth[i].children[0].firstChild.innerText == thisteeth.firstChild.innerText) {
                    allteeth[i].children[2].style.display = "block";
                    allteeth[i].children[0].style.display = "none";
                    allteeth[i].children[3].style.display = "block";
                } else {
                    allteeth[i].children[2].style.display = "none";
                    allteeth[i].children[3].style.display = "none";

                    for (let j = 0; j < highlightedId.length; j++) {
                        let a = parseInt(highlightedId[j]);
                        if (allteeth[i].getAttribute("id") == a) {
                            allteeth[i].children[0].style.display = "none";
                            allteeth[i].children[1].style.display = "block";
                            break;
                        } else {
                            allteeth[i].children[0].style.display = "block";
                        }
                    }
                }
            }
        }
        else if (document.querySelector(".reference-tab").className.includes('active-tab') && document.querySelector("#shed-tab").className.includes('active-ref-tab')) {
            let highlighted, shedStartYear;
            let teethinfo = '';
            let TeethSheddingData = this.state.TeethSheddingData;
            for (let i = 0; i < TeethSheddingData.length; i++) {
                if (TeethSheddingData[i].toothNumber == thisteeth.firstChild.innerText) {
                    this.setState({
                        toothName: TeethSheddingData[i].toothName,
                        toothMonth: TeethSheddingData[i].startYearShedding + '-' + TeethSheddingData[i].endYearShedding + ' years'
                    });
                    highlighted = TeethSheddingData[i].highlightedTeeth;
                    shedStartYear = TeethSheddingData[i].startYearShedding;
                    break;
                }
            }
            if (mon != 0) {
                this.weekInfo(0, shedStartYear);
            }
            document.querySelector(".shedding-sect .tooth-info").style.display = "block";
            document.querySelector(".shedding-sect .lower-jaw").style.display = "none";
            document.querySelector(".shedding-sect .upper-jaw").style.display = "none";

            let allteeth = this.state.allteeth;
            let highlightedId = highlighted.split(",");
            for (let i = 0; i < allteeth.length; i++) {
                allteeth[i].children[0].style.display = "none";
                if (allteeth[i].children[0].firstChild.innerText == thisteeth.firstChild.innerText) {
                    allteeth[i].children[2].style.display = "block";
                    allteeth[i].children[1].style.display = "none";
                    allteeth[i].children[3].style.display = "block";
                } else {
                    allteeth[i].children[2].style.display = "none";
                    allteeth[i].children[3].style.display = "none";

                    for (let j = 0; j < highlightedId.length; j++) {
                        let a = parseInt(highlightedId[j]);
                        if (allteeth[i].getAttribute("id") == a) {
                            allteeth[i].children[1].style.display = "none";
                            allteeth[i].children[0].style.display = "block";
                            break;
                        } else {
                            allteeth[i].children[1].style.display = "block";
                        }
                    }
                }
            }
        }
        else if (document.querySelector(".tooth-erptn-tab").className.includes('active-tab')) {
            var chlerpStartMth;
            var teethinfo;
            var datecount = 0, firstDate, ishighlight = 0;
            let ChildTeethData = this.state.ChildTeethData;
            let allteeth = this.state.allteeth;
            for (let j = 0; j < allteeth.length; j++) {
                allteeth[j].children[1].style.display = "none";
            }
            for (let i = 0; i < ChildTeethData.length; i++) {
                if (thisteeth.firstChild.innerText == ChildTeethData[i].toothNumber) {
                    if (ChildTeethData[i].isHighLited == 1) {
                        document.getElementById(ChildTeethData[i].toothId).children[1].style.display = "block";
                        ishighlight = 1;
                    }
                    if (datecount == 0) {
                        firstDate = ChildTeethData[i].toothErruptionDate;
                        datecount++;
                    } else {
                        if (firstDate >= ChildTeethData[i].toothErruptionDate) {
                            this.setState({
                                toothName: ChildTeethData[i].toothName,
                                toothMonth: ChildTeethData[i].startMonth + '-' + ChildTeethData[i].endMonth + ' months'
                            });
                            var onlyDate = new Date(firstDate);
                            var yr = onlyDate.getFullYear();
                            var mn = onlyDate.getMonth() + 1;
                            var dy = onlyDate.getDate();
                            teethinfo = dy + '-' + mn + '-' + yr;
                            this.setState({ userDate: teethinfo });
                            break
                        } else {
                            this.setState({
                                toothName: ChildTeethData[i].toothName,
                                toothMonth: ChildTeethData[i].startMonth + '-' + ChildTeethData[i].endMonth + ' months'
                            });
                            var onlyDate = new Date(ChildTeethData[i].toothErruptionDate);
                            var yr = onlyDate.getFullYear();
                            var mn = onlyDate.getMonth() + 1;
                            var dy = onlyDate.getDate();
                            teethinfo = dy + '-' + mn + '-' + yr;
                            this.setState({ userDate: teethinfo });
                            break
                        }
                    }
                    chlerpStartMth = ChildTeethData[i].startMonth
                }
            }
            if (mon != 0) {
                this.weekInfo(0, chlerpStartMth);
            }
            if (ishighlight == 0) {
                document.querySelector(".tooth-erptn-section .tooth-info").style.display = "none";
                document.querySelector(".tooth-erptn-section .lower-jaw").style.display = "block";
                document.querySelector(".tooth-erptn-section .upper-jaw").style.display = "block";
            } else {
                document.querySelector(".tooth-erptn-section .tooth-info").style.display = "block";
                document.querySelector(".tooth-erptn-section .lower-jaw").style.display = "none";
                document.querySelector(".tooth-erptn-section .upper-jaw").style.display = "none";
            }
        }
    }

    erptnInfo(thismonth) {
        var erpsrtmth = document.querySelector(".erruption-sect").getElementsByClassName("erpstartmonth");
        var erpendmth = document.querySelector(".erruption-sect").getElementsByClassName("erpendmonth");
        var z, a, b, c, success;
        let allteeth = this.state.allteeth;
        for (let i = 0; i < erpsrtmth.length; i++) {
            a = thismonth;
            b = erpsrtmth[i].value;
            c = erpendmth[i].value;

            if (a == b) {
                z = erpsrtmth[i].parentElement.firstChild.getAttribute("id");
                success = 1;
                break
            } else if (a <= 5) {
                for (let j = 0; j < allteeth.length; j++) {
                    allteeth[j].children[2].style.display = "none";
                    allteeth[j].children[1].style.display = "none";
                    allteeth[j].children[0].style.display = "block";
                    allteeth[j].children[3].style.display = "none";
                }
                document.querySelector(".erruption-sect .tooth-info").style.display = "none";
                document.querySelector(".erruption-sect .lower-jaw").style.display = "block";
                document.querySelector(".erruption-sect .upper-jaw").style.display = "block";
                z = 0;
                success = 1;
                break
            } else if (a > 25 && a < 34) {
                z = 'pink_20';
                success = 1;
            } else if (a > 33) {
                for (let j = 0; j < allteeth.length; j++) {
                    allteeth[j].children[2].style.display = "none";
                    allteeth[j].children[1].style.display = "block";
                    allteeth[j].children[0].style.display = "none";
                    allteeth[j].children[3].style.display = "none";
                }
                document.querySelector(".erruption-sect .tooth-info").style.display = "none";
                document.querySelector(".erruption-sect .lower-jaw").style.display = "block";
                document.querySelector(".erruption-sect .upper-jaw").style.display = "block";
                z = 0
            }
        }
        if (success != 1) {
            for (let i = 0; i < erpsrtmth.length; i++) {
                a = parseInt(thismonth);
                b = parseInt(erpsrtmth[i].value);
                c = parseInt(erpendmth[i].value);
                if (b < a && a < c) {
                    z = erpsrtmth[i].parentElement.firstChild.getAttribute("id");
                    break
                }
            }
        }
        if (z != 0) {
            this.showDet(0, z);
        }
    }
    shedInfo(thisyear) {
        let shedsrtyr = document.querySelector(".shedding-sect").getElementsByClassName("erpstartmonth");
        let shedendyr = document.querySelector(".shedding-sect").getElementsByClassName("erpendmonth");
        var z, a, b, c, success;
        let allteeth = this.state.allteeth;
        for (let i = 0; i < shedsrtyr.length; i++) {
            a = thisyear;
            b = shedsrtyr[i].value;
            c = shedendyr[i].value;

            if (a == b) {
                z = shedsrtyr[i].parentElement.firstChild.getAttribute("id");
                success = 1;
                break
            } else if (a == 12) {
                for (let j = 0; j < allteeth.length; j++) {
                    allteeth[j].children[2].style.display = "none";
                    allteeth[j].children[1].style.display = "none";
                    allteeth[j].children[0].style.display = "block";
                    allteeth[j].children[3].style.display = "none";
                }
                document.querySelector(".shedding-sect .tooth-info").style.display = "none";
                document.querySelector(".shedding-sect .lower-jaw").style.display = "block";
                document.querySelector(".shedding-sect .upper-jaw").style.display = "block";
                z = 0;
                success = 1;
                break
            }
        }
        if (success != 1) {
            for (let i = 0; i < shedsrtyr.length; i++) {
                a = thisyear;
                b = shedsrtyr[i].value;
                c = shedendyr[i].value;
                if (b < a && a <= c) {
                    z = shedsrtyr[i].parentElement.firstChild.getAttribute("id");
                    break
                }
            }
        }
        if (z != 0) {
            this.showDet(0, z);
        }
    }
    chlErptnInfo(thismonth) {
        var chlsrtmn = document.querySelector(".tooth-erptn-section").getElementsByClassName("childstartmonth");
        var chlendmn = document.querySelector(".tooth-erptn-section").getElementsByClassName("childendmonth");
        var z, a, b, c, success;
        let allteeth = this.state.allteeth;
        for (let i = 0; i < chlsrtmn.length; i++) {
            a = thismonth;
            b = chlsrtmn[i].value;
            c = chlendmn[i].value;

            if (a == b) {
                z = chlsrtmn[i].parentElement.firstChild.getAttribute("id");
                success = 1;
                break
            } else if (a <= 5) {
                for (let j = 0; j < allteeth.length; j++) {
                    allteeth[j].children[1].style.display = "none";
                }
                document.querySelector(".tooth-erptn-section .tooth-info").style.display = "none";
                document.querySelector(".tooth-erptn-section .lower-jaw").style.display = "block";
                document.querySelector(".tooth-erptn-section .upper-jaw").style.display = "block";
                z = 0;
                success = 1;
                break
            } else if (a > 25 && a < 34) {
                z = chlsrtmn[i].parentElement.firstChild.getAttribute("id");
                success = 1;
            } else if (a > 33) {
                for (let j = 0; j < allteeth.length; j++) {
                    allteeth[j].children[1].style.display = "none";
                }
                document.querySelector(".tooth-erptn-section .tooth-info").style.display = "none";
                document.querySelector(".tooth-erptn-section .lower-jaw").style.display = "block";
                document.querySelector(".tooth-erptn-section .upper-jaw").style.display = "block";
                success = 1;
                z = 0
            }
        }
        if (success != 1) {
            for (let i = 0; i < chlsrtmn.length; i++) {
                a = parseInt(thismonth);
                b = parseInt(chlsrtmn[i].value);
                c = parseInt(chlendmn[i].value);
                if (b < a && a < c) {
                    z = chlsrtmn[i].parentElement.firstChild.getAttribute("id");
                    break
                }
            }
        }
        if (z != 0) {
            this.showDet(0, z);
        }
    }
    childrenlist() {
        if (this.state.isshowDropdown === false) {
            this.setState({ isshowDropdown: true })
        } else {
            this.setState({ isshowDropdown: false })
        }
    }

    selectChild(childId, childName, childDOB) {
        this.setState({ selectedChlId: childId, isshowDropdown: false, selectedChlname: childName, selectedChlDOB: childDOB });
        this.getErptData(childId);
        this.getShedData(childId);
        this.getChildData(childId);

        setTimeout(() => {
            if(this.state.isshowRef && this.state.isshowErpt){
                this.setState({ 
                    TeethEruptionData: this.state.initialData.data1.result
                });
            } else if (this.state.isshowRef && this.state.isshowShed){
                this.setState({ 
                    TeethSheddingData: this.state.initialData.data2.result
                });
            } else if(this.state.isshowChildTeeth) {
                this.setState({ 
                    ChildTeethData: this.state.initialData.data3.result
                });
            } 
        }, 1000);
    }

    render() {
       let userchildarray = global.userAry['childData'] && global.userAry['childData']['UserChildList'] ? global.userAry['childData']['UserChildList'] : '';

        return (
            <main className="main-container">
                <Helmet
                    title="Baby Teething Tracker Tool - FirstCry Parenting"
                    meta={[
                        { "name": "description", "content": "Keeping track of your baby's teeth is indeed a tough task, teething tracker tool will help you to know when do babies start teething, at what age your child's tooth erupt & shed. Get teething information at FirstCry Parenitng." },
                        { "name": "keywords", "content": "teething tools for babies, baby teeth tracker, baby teething tool" },
                        { "name": "atdlayout", "content": "tools_sp" }
                    ]}
                />
                <div className="title">
                    <div className="breadcrumb R11_9e">
                        <span><Link to={service.getRedirectUrl("/")} className="R11_9e">Home</Link></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span><Link to={service.getRedirectUrl("/tools")} className="R11_9e">Tools</Link></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span>Baby Teething</span>
                    </div>
                    <h1 className="B24_00">{this.state.isshowDetails ? "Add Tooth Eruption Details " : "Baby Teething Tool "} {(this.state.isLogin && this.state.selectedChlname) ? <span>for {this.state.selectedChlname}</span> : null}</h1>
                </div>
                <div className="sub-container left baby-teething-tool">
                    {this.state.isshowDetails ?
                        <AddToothDetails ChildTeethData={this.state.ChildTeethData} eleRef={this} thisTooth={this.state.insertThisTooth} /> :
                        <div className="baby-teething-main data-container left">
                            {this.state.showChildrenList ?
                                <div id="childDropdown">
                                {userchildarray && userchildarray.map(childarray =>
                                        (childarray.ChildId == this.state.selectedChlId) ?
                                    <div key={childarray.ChildId} className="drop-down" onClick={() => this.childrenlist()}>
                                        <input type="hidden" id="selectedChildId" name="selectedChildId" value={childarray.ChildId} />
                                        <div className="selected-child">
                                            <div className="M20_pink">
                                                <span className="childPic">
                                                    {childarray.childPhoto == '' ?
                                                        <img src='https://cdn.fcglcdn.com/brainbees/parenting/img/m/default-img.png' /> :
                                                        <img src={childarray.childPhoto} />
                                                    }
                                                </span>
                                                <input type="hidden" id="selectedChildDOB" name="selectedChildDOB" value={childarray.DOB} />
                                                <input type="hidden" id="selectedChildName" name="selectedChildName" value={childarray.ChildName} />
                                                <div className="diet-title">{childarray.ChildName}</div>

                                                {(userchildarray.length > 1 && !userchildarray[0].IsExpected) || (userchildarray.length > 2 && userchildarray[0].IsExpected) ?
                                                    <span data-icon-font="f" className="M18_pink dropbtn right"></span> : null
                                                }
                                            </div>
                                        </div>
                                    </div> : null
                                )}
                                {userchildarray && userchildarray.length > 0 && (userchildarray.length > 1 && !userchildarray[0].IsExpected) || ( userchildarray.length > 2 && userchildarray[0].IsExpected) ?
                                    <div className="dropdown">
                                        <div id="myDropdown" className="dropdown-content" style={{ display: (this.state.isshowDropdown ? 'block' : 'none') }}>
                                            {userchildarray && userchildarray.map(childarray =>
                                                (!childarray.IsExpected) ?
                                                <div key={childarray.ChildId} className="children" id={childarray.ChildId} onClick={() => this.selectChild(childarray.ChildId, childarray.ChildName, childarray.DOB)} style={{ background: (childarray.ChildId == this.state.selectedChlId ? '#f5f5f5' : '#fff') }} data-id={childarray.DOB}>
                                                    <span className="childPic">
                                                        {childarray.childPhoto == '' ?
                                                            <img src='https://cdn.fcglcdn.com/brainbees/parenting/img/m/default-img.png' className="childprofPic" data-id={childarray.DOB}/> :
                                                            <img src={childarray.childPhoto} />
                                                        }
                                                    </span>
                                                    <span className="child_name R16_42" data-id={childarray.DOB}>{childarray.ChildName}</span>
                                                    {(childarray.ChildId == this.state.selectedChlId) ?
                                                        <span className="current_child right" data-icon-font=";"></span> : null
                                                    }
                                                </div> : null
                                            )}
                                        </div>
                                    </div> : null
                                }
                                </div> : null
                            }
                            <div className="baby-teeth-tabs">
                                <div className={"tabs reference-tab " + this.state.activeRef} data-id="#ref" id="ref-tab" onClick={() => this.showTabContent('ref')}>
                                    <span className="M16_61">REFERENCE</span>
                                </div>
                                <div className={"tabs tooth-erptn-tab " + this.state.activeTotRef} data-id="#tot-ertp" onClick={() => this.showTabContent('totref')}>
                                    <span className="M16_61">TOOTH ERUPTION</span>
                                </div>
                                <div className={"tabs articles-tab " + this.state.activeArti} data-id="#art" onClick={() => this.showTabContent('arti')}>
                                    <span className="M16_61">ARTICLES</span>
                                </div>
                            </div>
                            {this.state.isshowRef ?
                                <div className="reference-section all-sect" id="ref" style={{ display: (this.state.isshowRef ? 'block' : 'none') }}>
                                    <div className="referene-tabs">
                                        <div className={"ref-tab M14_9e " + this.state.activeErp} id="errp-tab" onClick={(e) => this.showRefContent('erp')}>
                                            <div>ERUPTION</div>
                                            <div className={this.state.tabarrow == "erparrow" ? "tab-arrow" : ""}></div>
                                        </div>
                                        <div className={"ref-tab M14_9e " + this.state.activeShed} id="shed-tab" onClick={(e) => this.showRefContent('shed')}>
                                            <div>SHEDDING</div>
                                            <div className={this.state.tabarrow == "shedarrow" ? "tab-arrow" : ""}></div>
                                        </div>
                                        <span data-icon-font="R" className="info-icon" onClick={() => this.showtoastmsg()}></span>
                                    </div>
                                    {this.state.isshowErpt ?
                                        <div className="erruption-sect" style={{ display: (this.state.isshowErpt ? 'block' : 'none') }}>
                                            <Eruption TeethEruptionData={this.state.TeethEruptionData} eleRef={this} />
                                        </div> :
                                        <div className="shedding-sect" style={{ display: (this.state.isshowShed ? 'block' : 'none') }}>
                                            <Shedding TeethSheddingData={this.state.TeethSheddingData} eleRef={this} />
                                            {/* <Eruption TeethEruptionData = {this.state.TeethEruptionData} TeethSheddingData = {this.state.TeethSheddingData} eleRef={this} whichSection={'shedding-sect'}/> */}
                                        </div>
                                    }
                                </div> :
                                this.state.isshowChildTeeth ?
                                    <div className="tooth-erptn-section all-sect" id="tot-ertp" style={{ display: (this.state.isshowChildTeeth ? 'block' : 'none') }}>
                                        <ChildTeethInfo ChildTeethData={this.state.ChildTeethData} eleRef={this} />
                                    </div> :

                                    <div className="articles-section all-sect" id="art" style={{ display: (this.state.isshowArt ? 'block' : 'none') }}>
                                        <Articles ArticlesData={this.state.ArticlesData} eleRef={this} />
                                        <div className="share-overlay"></div>
                                    </div>
                            }
                        </div>
                    }
                </div>
                <div className="toast-msg" style={{ display: (this.state.showmsg ? 'block' : 'none') }}>
                    <div className="message">
                        The chart shows when your child’s primary teeth should erupt and shed. Eruption/Shedding timeline varies from child to child
                    </div>
                </div>
                <div className="test-internet-error">
                    <div className="save-success">
                        Please check internet connection
                    </div>
                </div>
                <Right url={this.props.match.url} />
            </main>
        )

    }
}

export default BabyTeething;



// WEBPACK FOOTER //
// src/shared/tools/baby-teething/BabyTeething.js